import React from 'react';

const Menu2 = () => {
    return (
        <div className="main-wrapper pt_0 pb_0">

            <div className="section_sm">
                <div className="container">
                    <div className="section_header sm_padding">
                        <img src="images/title_border.png" alt="" />
                        <h2 className="section_title">Starter</h2>
                        <h6 className="section_sub_title">Find your favourite meal from the delicious options we have</h6>
                    </div>

                    <div className="foodmenu_tab">
                        <div className="foodmenu_tab_container with_photo">
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/1.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Chicken Avocado Sandwitch</div>
                                                <div className="line"></div>
                                                <div className="price">$ 220</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/2.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Banana Nut Pancakes</div>
                                                <div className="line"></div>
                                                <div className="price">$ 180</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/3.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Swiss Hash Browns</div>
                                                <div className="line"></div>
                                                <div className="price">$ 110</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/4.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Perfect Scrambled Eggs</div>
                                                <div className="line"></div>
                                                <div className="price">$ 150</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/5.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Sesame Noodles with Garlic</div>
                                                <div className="line"></div>
                                                <div className="price">$ 130</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/6.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Beer-Cheeseburger</div>
                                                <div className="line"></div>
                                                <div className="price">$ 154</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/7.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Spaghetti carbonara</div>
                                                <div className="line"></div>
                                                <div className="price">$ 220</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/8.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Grilled Cheese Crostini</div>
                                                <div className="line"></div>
                                                <div className="price">$ 180</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/9.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Chicken Avocado Sandwitch</div>
                                                <div className="line"></div>
                                                <div className="price">$ 110</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/10.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Roasted Veggie Chips</div>
                                                <div className="line"></div>
                                                <div className="price">$ 150</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/11.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">One-Pot Beef with Broccoli</div>
                                                <div className="line"></div>
                                                <div className="price">$ 130</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/12.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Pesto Chicken Bake</div>
                                                <div className="line"></div>
                                                <div className="price">$ 154</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bgimage_section_divider bg_image_16"></div>

            <div className="section_sm">
                <div className="container">
                    <div className="section_header sm_padding">
                        <img src="images/title_border.png" alt="" />
                        <h2 className="section_title">Main Course</h2>
                        <h6 className="section_sub_title">Find your favourite meal from the delicious options we have</h6>
                    </div>

                    <div className="foodmenu_tab">
                        <div className="foodmenu_tab_container with_photo">
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/1.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Chicken Avocado Sandwitch</div>
                                                <div className="line"></div>
                                                <div className="price">$ 220</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/2.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Banana Nut Pancakes</div>
                                                <div className="line"></div>
                                                <div className="price">$ 180</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/3.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Swiss Hash Browns</div>
                                                <div className="line"></div>
                                                <div className="price">$ 110</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/4.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Perfect Scrambled Eggs</div>
                                                <div className="line"></div>
                                                <div className="price">$ 150</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/5.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Sesame Noodles with Garlic</div>
                                                <div className="line"></div>
                                                <div className="price">$ 130</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/6.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Beer-Cheeseburger</div>
                                                <div className="line"></div>
                                                <div className="price">$ 154</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/7.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Spaghetti carbonara</div>
                                                <div className="line"></div>
                                                <div className="price">$ 220</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/8.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Grilled Cheese Crostini</div>
                                                <div className="line"></div>
                                                <div className="price">$ 180</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/9.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Chicken Avocado Sandwitch</div>
                                                <div className="line"></div>
                                                <div className="price">$ 110</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/10.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Roasted Veggie Chips</div>
                                                <div className="line"></div>
                                                <div className="price">$ 150</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/11.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">One-Pot Beef with Broccoli</div>
                                                <div className="line"></div>
                                                <div className="price">$ 130</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/12.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Pesto Chicken Bake</div>
                                                <div className="line"></div>
                                                <div className="price">$ 154</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bgimage_section_divider bg_image_17 jarallax"></div>

            <div className="section_sm">
                <div className="container">
                    <div className="section_header sm_padding">
                        <img src="images/title_border.png" alt="" />
                        <h2 className="section_title">Dessert</h2>
                        <h6 className="section_sub_title">Find your favourite meal from the delicious options we have</h6>
                    </div>

                    <div className="foodmenu_tab">
                        <div className="foodmenu_tab_container with_photo">
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/13.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Chicken Avocado Sandwitch</div>
                                                <div className="line"></div>
                                                <div className="price">$ 220</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/14.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Banana Nut Pancakes</div>
                                                <div className="line"></div>
                                                <div className="price">$ 180</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/15.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Swiss Hash Browns</div>
                                                <div className="line"></div>
                                                <div className="price">$ 110</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/16.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Perfect Scrambled Eggs</div>
                                                <div className="line"></div>
                                                <div className="price">$ 150</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/17.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Sesame Noodles with Garlic</div>
                                                <div className="line"></div>
                                                <div className="price">$ 130</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/18.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Beer-Cheeseburger</div>
                                                <div className="line"></div>
                                                <div className="price">$ 154</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-6">
                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/19.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Spaghetti carbonara</div>
                                                <div className="line"></div>
                                                <div className="price">$ 220</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/20.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Grilled Cheese Crostini</div>
                                                <div className="line"></div>
                                                <div className="price">$ 180</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/21.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Chicken Avocado Sandwitch</div>
                                                <div className="line"></div>
                                                <div className="price">$ 110</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/22.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Roasted Veggie Chips</div>
                                                <div className="line"></div>
                                                <div className="price">$ 150</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/23.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">One-Pot Beef with Broccoli</div>
                                                <div className="line"></div>
                                                <div className="price">$ 130</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>

                                    <div className="foodmenu_tab_content">
                                        <div className="menu_serial"><img src="images/menu/24.jpg" alt="" /></div>
                                        <div className="menu_item">
                                            <div className="menu_item_inner">
                                                <div className="name">Pesto Chicken Bake</div>
                                                <div className="line"></div>
                                                <div className="price">$ 154</div>
                                            </div>
                                            <p>Lorem ipsum dolor sit amet consecturer duis</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bgimage_section_divider bg_image_18"></div>

        </div>
    );
};

export default Menu2;